<label *ngIf="label">{{label}}</label>
<div 
    *ngIf="loaded"
    [class]="size"
    [ngxSummernote]="config" 
    [ngxSummernoteView]="value"
    [ngClass]="error ? 'error' : ''"
    (summernoteModelChange)="onChange($event)"
></div>
<div class="error-message" *ngIf="error">{{error}}</div>